import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48481d8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-account-title mx-6 mt-2" }
const _hoisted_2 = {
  key: 0,
  class: "ul-profile"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  "background-color": "red-65",
  class: "tag-postion"
}
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = {
  class: "tick-round",
  "data-testid": "tick"
}
const _hoisted_8 = {
  key: 1,
  class: "m-6"
}
const _hoisted_9 = { key: 1 }

import { useRoute } from 'vue-router'
import { onMounted, ref } from 'vue'

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import ProfilePicture from '@/popup/components/shared/ProfilePicture/ProfilePicture.vue'
import getBase64FromUrl from '@/shared/getBase64FromUrl'
import Spinner from '@/popup/components/shared/Spinner.vue'
import ApprovalHeader from '@/popup/components/shared/ApprovalHeader.vue'
import { useAppStore } from '@/popup/store/AppStore'
import { PopupDatabase } from '@/popup/storage/Database'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { APPROVAL_ACTION } from '@/shared/apis/approvals'
import { DropdownProfile, UpAddress } from '@/shared/models/Profile'
import { useFixedHeader } from '@/popup/compositions/useFixedHeader'
import { ControllerDTO } from '@/business-logic/profile'

type Props = {
  onlyOneSelection: boolean
  hasError?: boolean
  defaultSelectedKeys: string[]
  isSubmitting?: boolean
  handleAccept(selected: string[], action: APPROVAL_ACTION): Promise<void>
  handleSelect?(): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAccount',
  props: {
    onlyOneSelection: { type: Boolean },
    hasError: { type: Boolean },
    defaultSelectedKeys: {},
    isSubmitting: { type: Boolean },
    handleAccept: { type: Function },
    handleSelect: { type: Function }
  },
  setup(__props: any) {

const props = __props
const route = useRoute()
const id = route.params['id']
const appStore = useAppStore()
const approvalsStore = useApprovalsStore()
const approval = approvalsStore.getApproval(id)
const selected = ref<string[]>([])
const icon = (approval?.requestData as { icon?: string }).icon
const onMountedRun = ref(false)
const contentRef = ref<InstanceType<typeof HTMLElement>>()
const scrollOffset = ref<number>(100)
const deviceControllers = ref<Record<UpAddress, ControllerDTO>>({})
const { onContentScroll, scrollPercentage } = useFixedHeader(
  scrollOffset,
  contentRef
)

onMounted(async () => {
  selected.value = props.defaultSelectedKeys || []
  if (approval?.origin) {
    const originMeta = {
      url: encodeURI(approval.origin),
      icon: icon && (await getBase64FromUrl(icon)),
    }
    await PopupDatabase.put('origins', originMeta)
  }
  onMountedRun.value = true
})

onMounted(async () => {
  deviceControllers.value =
    await appStore.getAllUniversalProfilesDeviceControllers()
})

const handleSelected = (key: string) => {
  if (isReadonly(key)) {
    return
  }
  if (selected.value.includes(key)) {
    selected.value = selected.value.filter(s => s !== key)
  } else {
    props.onlyOneSelection ? (selected.value = [key]) : selected.value.push(key)
  }
  props.handleSelect && props.handleSelect()
}

const createdAtDesc = (a: DropdownProfile, b: DropdownProfile) => {
  if (
    a.address === appStore.selectedProfile ||
    b.address === appStore.selectedProfile
  ) {
    return 0
  }

  if (!a.createdAt || !b.createdAt) {
    return 0
  }

  if (a.createdAt > b.createdAt) {
    return -1
  } else if (a.createdAt < b.createdAt) {
    return 1
  }

  return 0
}

const selectedProfileFirst = (a: DropdownProfile) => {
  if (a.address === appStore.selectedProfile) {
    return -1
  }

  return 0
}

const profiles = appStore.dropdownAddresses
  .sort(createdAtDesc)
  .sort(selectedProfileFirst)

const isReadonly = (address: string) => {
  return (
    !deviceControllers.value[address] ||
    deviceControllers.value[address]?.permissions?.controlLevel === 'None'
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", { 'has-error': _ctx.hasError }])
  }, [
    _createElementVNode("section", {
      ref_key: "contentRef",
      ref: contentRef,
      class: "select-account is-flex is-flex-direction-column",
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onContentScroll) && _unref(onContentScroll)(...args)))
    }, [
      _createVNode(ApprovalHeader, { icon: _unref(icon) }, {
        title: _withCtx(() => [
          _renderSlot(_ctx.$slots, "title")
        ]),
        subtitle: _withCtx(() => [
          _renderSlot(_ctx.$slots, "subtitle")
        ]),
        actions: _withCtx(() => [
          _renderSlot(_ctx.$slots, "actions")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["icon"]),
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "select-account-title")
      ]),
      (_ctx.hasError)
        ? _renderSlot(_ctx.$slots, "relayer-error", { key: 0 })
        : _createCommentVNode("v-if", true),
      _createElementVNode("section", {
        class: _normalizeClass(["main mt-6", { loaded: onMountedRun.value, profiles: _unref(profiles).length < 7 }])
      }, [
        (_unref(appStore).dropdownAddresses.length > 0 && onMountedRun.value)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profiles), (profile) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: profile.address,
                  class: _normalizeClass(["li-profile", { 'disable-cursor': isReadonly(profile.address) }]),
                  onClick: ($event: any) => (handleSelected(profile.address))
                }, [
                  (isReadonly(profile.address))
                    ? (_openBlock(), _createElementBlock("lukso-tag", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('profile_card.read_only')), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    "data-testid": profile.address,
                    class: _normalizeClass(["profile button is-secondary", {
                selected: selected.value.includes(profile.address),
                'reduce-visibility': isReadonly(profile.address),
              }])
                  }, [
                    _createVNode(ProfilePicture, {
                      size: "medium",
                      "frontend-profile": profile,
                      "with-name": true
                    }, null, 8 /* PROPS */, ["frontend-profile"]),
                    _withDirectives(_createElementVNode("div", _hoisted_7, [
                      _createVNode(SvgIcon, {
                        name: "tick",
                        color: "var(--neutral-90)",
                        width: "16",
                        height: "16",
                        "stroke-width": "2"
                      })
                    ], 512 /* NEED_PATCH */), [
                      [_vShow, selected.value.includes(profile.address)]
                    ])
                  ], 10 /* CLASS, PROPS */, _hoisted_6)
                ], 10 /* CLASS, PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('select_account.empty_state')), 1 /* TEXT */))
      ], 2 /* CLASS */)
    ], 544 /* NEED_HYDRATION, NEED_PATCH */),
    _createElementVNode("div", {
      class: _normalizeClass(["", `buttons ${
        _unref(scrollPercentage) < 80 && _unref(profiles).length > 4 ? 'shadow' : ''
      }`])
    }, [
      _createVNode(Button, {
        variant: "text",
        "is-full-width": true,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleAccept(selected.value.slice(), 'REJECTED')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('select_account.button.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Button, {
        disabled: selected.value.length === 0 || !!_ctx.hasError,
        variant: "primary",
        "is-full-width": true,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleAccept(selected.value.slice(), 'CONFIRMED')))
      }, {
        default: _withCtx(() => [
          (_ctx.isSubmitting)
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                class: "center-spinner"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('select_account.button.accept')), 1 /* TEXT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})